export default function Ngone() {
    return null;
}
